import { render, staticRenderFns } from "./BonusTileForm.vue?vue&type=template&id=070dc1aa&"
import script from "./BonusTileForm.vue?vue&type=script&lang=js&"
export * from "./BonusTileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports